import { html, css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faPaperPlane,
  faFilePen,
  faFileCircleCheck,
  faBookOpen,
  faCheckCircle,
  faCrosshairs,
  faPoll,
} from '@fortawesome/pro-regular-svg-icons';

import { variables, svgWithJs } from '../variables';

@customElement('apt-panel-card')
export class PanelCard extends LitElement {
  @property({ type: String })
  icon = '';
  @property({ type: String })
  cardTitle = '';
  @property({ type: String })
  description = '';

  static override get styles() {
    return [
      variables,
      svgWithJs,
      css`
        :host {
          font-family: var(--font-family-sans-serif);
          font-style: normal;
        }
        .text-muted {
          color: var(--gray-600);
        }
        h4 {
          font-size: 20px;
          margin-block-start: 0px;
          margin-block-end: 0px;
          margin-bottom: 1rem;
          font-weight: 500;
          line-height: 24px;
        }
        .description {
          font-size: 15px;
          font-weight: 400;
          line-height: 18px;
        }
        .pb-3 {
          padding-bottom: 1rem;
        }
        .icon {
          font-size: 20px;
          line-height: 20px;
          padding-bottom: 10px;
        }
      `,
    ];
  }

  override render() {
    return html`
      <span class="fa-layers icon">
        <i class="fa fa-regular ${this.icon}"></i>
      </span>
      <h4>${this.cardTitle}</h4>
      <div class="text-muted pb-3 description">${this.description}</div>
      <slot></slot>
    `;
  }

  protected override firstUpdated(): void {
    library.add(
      faPaperPlane,
      faFilePen,
      faFileCircleCheck,
      faBookOpen,
      faCheckCircle,
      faCrosshairs,
      faPoll,
    );

    // @ts-ignore The dom.watch() TS definition indicates no parameters for this. However, when
    // you actually dig into the code, you see that it looks at the arguments after it gets into
    // the code and tries to pull some out if there aren't any (it even supplies an empty object
    // for options if you don't supply one yourself).
    //
    // Note: We have to wait for the first update for the shadow DOM to even be created.
    dom.watch({
      autoReplaceSvgRoot: this.shadowRoot,
      observeMutationsRoot: this.shadowRoot,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'apt-panel-card': PanelCard;
  }
}
